<template>
  <section class="quiz-description">
    <header class="container-sm">
      <span class="quiz-description__label">{{ $t('viewer.page.quiz.desc.label') }}</span>
    </header>

    <content-viewer :page="quiz" :content="description" :isDescription="true"/>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import ContentViewer from './ContentViewer';

export default {
  name: 'quiz-description',

  props: [
    'quiz',
    'content',
  ],

  components: {
    ContentViewer,
  },

  computed: {
    ...mapGetters({
      isResult: 'getIsResult',
      quizResult: 'getQuizResult',
    }),

    description() {
      if (this.quizResult.comment) {
        return `<p>${this.quizResult.comment.replace(/\n/g, '<br>')}</p>`;
      }

      return this.quiz.description;
    },
  },
};
</script>
<style lang="scss">
  .quiz-description {
    padding-top: 20px;

    .quiz-description__label {
      font-size: 14px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.54);
      padding: 6px 0px 6px 0px;
    }
  }
</style>
